<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Vehicle</h4>
            </li>
            <!-- <li class="breadcrumb-item bcrumb-1">
              <a routerLink="/dashboard/main">
                <i class="fas fa-home"></i> Home</a>
            </li>
            <li class="breadcrumb-item bcrumb-2">
              <a href="#" onClick="return false;">Forms</a>
            </li>
            <li class="breadcrumb-item active">Basic</li> -->
          </ul>
        </div>
      </div>
    </div>
    <!-- <app-maser-page-header></app-maser-page-header> -->
    <div class="row">
      <div class="col" *ngIf="!this.vehicleService.is_display_vehicle_register_component">
        <button mat-fab color="primary" (click)="registerVehicle()">
          <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon>
        </button>
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
          <ng-container matColumnDef="id">
            <th style="background: #97cdef;" mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
            <td mat-cell *matCellDef="let element;let i=index"> {{i+1}}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th style="background: #97cdef;" mat-header-cell *matHeaderCellDef mat-sort-header> Name
              <mat-form-field class="filter" floatLabel="never" style="margin-left: 15px;">
                <mat-label>Search by name</mat-label>
                <input matInput [formControl]="nameFilter">
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.name}}
                </div>

              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="code">
            <th style="background: #97cdef;" mat-header-cell *matHeaderCellDef mat-sort-header> Code
              <mat-form-field class="filter" floatLabel="never" style="margin-left: 15px;">
                <mat-label>Search by code</mat-label>
                <input matInput [formControl]="codeFilter">
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.code}}
                </div>

              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="licence_number">
            <th style="background: #97cdef;" mat-header-cell *matHeaderCellDef mat-sort-header> Licence Number
              <mat-form-field class="filter" floatLabel="never" style="margin-left: 15px;">
                <mat-label>Search by licence_number</mat-label>
                <input matInput [formControl]="licenceFilter">
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.licence_number}}
                </div>

              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="driver_name">
            <th style="background: #97cdef;" mat-header-cell *matHeaderCellDef mat-sort-header> Driver Name
              <mat-form-field class="filter" floatLabel="never" style="margin-left: 15px;">
                <mat-label>Search by driver_name</mat-label>
                <input matInput [formControl]="driverFilter">
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.driver_name}}
                </div>

              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="driver_mobile">
            <th style="background: #97cdef;" mat-header-cell *matHeaderCellDef mat-sort-header> Driver Mobile
              <mat-form-field class="filter" floatLabel="never" style="margin-left: 15px;">
                <mat-label>Search by driver mobile</mat-label>
                <input matInput [formControl]="driverMobileFilter">
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.driver_mobile}}
                </div>
                <div class="col" style="cursor : pointer">
                  <mat-icon (click)="editVehicle(element)">edit</mat-icon>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <div class="col-8" *ngIf="this.vehicleService.is_display_vehicle_register_component">
        <div class="row">
          <div class="col"></div>
          <div class="col-1">
            <button mat-fab color="primary" (click)="hideVehicleRegister()">
              <i class="material-icons">
                clear
              </i>
            </button>
          </div>
        </div>
        <app-vehicle-register></app-vehicle-register>
      </div>
    </div>
  </div>
</section>
